import { useCallback, useMemo, useRef, useState } from 'react'
import { TaskFormsState } from '../contexts/TaskFormsContext'

// The project forms of one tension (#123). Unlike next steps, none opens by
// itself: a project is created on demand, by the "Project" button.
// `threadId` is only watched, to start over on another tension — reset during
// render with a fresh key, for the reasons given in useNextStepForms.
export default function useTaskForms(threadId: string): TaskFormsState {
  const [forms, setForms] = useState<number[]>([])
  const nextKey = useRef(0)

  const [renderedThreadId, setRenderedThreadId] = useState(threadId)
  if (threadId !== renderedThreadId) {
    setRenderedThreadId(threadId)
    setForms([])
  }

  const addForm = useCallback(
    () => setForms((f) => [...f, nextKey.current++]),
    []
  )
  const removeForm = useCallback(
    (key: number) => setForms((f) => f.filter((k) => k !== key)),
    []
  )

  return useMemo(
    () => ({ forms, addForm, removeForm }),
    [forms, addForm, removeForm]
  )
}
